
import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import {
  runSubscriptionAudit,
  listSubscriptionAuditFindings,
  getSubscriptionAuditSummary,
  resolveSubscriptionAuditFinding,
  AuditFinding,
} from '@/api/subscriptionAudit'

@Component({ name: 'SubscriptionAudit', components: { Pagination } })
export default class extends Vue {
  private running = false
  private loadingFindings = false
  private summary: { runs: any[]; openByType: any[] } = { runs: [], openByType: [] }
  private findings: AuditFinding[] = []
  private total = 0

  private runForm = { platforms: ['ios', 'android'], sinceDays: 120, maxSubs: 2000 }
  private filter = {
    page: 1, limit: 50,
    auditRunId: '', platform: '', findingType: '', severity: '',
    userId: '', userEmail: '', unresolved: false
  }

  private detailVisible = false
  private detailJson = ''

  created() {
    this.loadSummary()
    this.loadFindings()
  }

  private async onRunAudit() {
    this.running = true
    try {
      await runSubscriptionAudit({
        platforms: this.runForm.platforms,
        sinceDays: this.runForm.sinceDays,
        maxSubs: this.runForm.maxSubs,
      })
      this.$message.success(this.$t('subscriptionAudit.auditStarted') as string)
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('subscriptionAudit.startFailed') as string)
    } finally {
      this.running = false
    }
  }

  private async loadSummary() {
    try {
      const res = await getSubscriptionAuditSummary()
      this.summary = res.data?.data || { runs: [], openByType: [] }
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('subscriptionAudit.summaryLoadFailed') as string)
    }
  }

  private async loadFindings() {
    this.loadingFindings = true
    try {
      const params: any = { page: this.filter.page, limit: this.filter.limit }
      if (this.filter.auditRunId) params.auditRunId = this.filter.auditRunId
      if (this.filter.platform) params.platform = this.filter.platform
      if (this.filter.findingType) params.findingType = this.filter.findingType
      if (this.filter.severity) params.severity = this.filter.severity
      if (this.filter.userId) params.userId = this.filter.userId
      if (this.filter.userEmail) params.userEmail = this.filter.userEmail
      if (this.filter.unresolved) params.unresolved = 'true'

      const res = await listSubscriptionAuditFindings(params)
      this.findings = res.data?.data?.items || []
      this.total = res.data?.data?.total || 0
    } catch (err: any) {
      this.$message.error(err.response?.data?.status?.message || this.$t('subscriptionAudit.findingsLoadFailed') as string)
    } finally {
      this.loadingFindings = false
    }
  }

  private resetFilter() {
    this.filter = { page: 1, limit: 50, auditRunId: '', platform: '', findingType: '', severity: '', userId: '', userEmail: '', unresolved: false }
    this.loadFindings()
  }

  private async resolve(row: AuditFinding) {
    try {
      await this.$prompt(this.$t('subscriptionAudit.resolutionNote') as string, this.$t('subscriptionAudit.markResolvedTitle') as string, { inputType: 'textarea' }).then(async (v: any) => {
        await resolveSubscriptionAuditFinding(row.id, v.value || '')
        this.$message.success(this.$t('subscriptionAudit.markedResolved') as string)
        this.loadFindings()
      })
    } catch { /* cancelled */ }
  }

  private showDetails(row: AuditFinding) {
    this.detailJson = JSON.stringify(row, null, 2)
    this.detailVisible = true
  }

  private severityTagType(s: string): string {
    if (s === 'critical') return 'danger'
    if (s === 'high') return 'warning'
    if (s === 'medium') return 'info'
    return ''
  }

  private formatDate(d: string | null | undefined): string {
    if (!d) return '-'
    const dt = new Date(d)
    return dt.toLocaleDateString('tr-TR') + ' ' + dt.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })
  }
}
